import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import ContentCard from '@/components/base/ContentCard';
import SectionHeading from '@/components/base/SectionHeading';
import { useFavorites } from '@/hooks/useFavorites';
import { articles } from '@/mocks/articles';
import { getHotArticles } from '@/utils/content';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Favorites() {
  usePageMeta('我的收藏 - 鲁啊鲁', '查看你在鲁啊鲁收藏的内容，收藏记录保存在当前浏览器本地。');
  const { favorites } = useFavorites();
  const saved = articles.filter((item) => favorites.includes(item.id));
  const recommended = getHotArticles(4).filter((item) => !favorites.includes(item.id));

  return (
    <div className="w-full px-4 md:px-8 py-6 md:py-8 pb-24 lg:pb-8">
      <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '我的收藏' }]} />

      <div className="mt-5 rounded-lg bg-primary-50 border border-primary-100 px-6 py-7 md:px-9 md:py-8">
        <h1 className="flex items-center gap-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-heart-3-line text-2xl"></i>
          </span>
          我的收藏
        </h1>
        <p className="mt-3 text-sm text-foreground-600">
          你收藏的内容保存在当前浏览器的本地存储中，共 <span className="font-semibold text-foreground-900">{saved.length}</span> 篇。
        </p>
      </div>

      {saved.length > 0 ? (
        <section className="mt-8">
          <SectionHeading title="已收藏内容" subtitle="随时回来继续阅读" icon="ri-bookmark-3-line" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {saved.map((article) => (
              <ContentCard key={article.id} article={article} />
            ))}
          </div>
        </section>
      ) : (
        <div className="mt-8 rounded-lg border border-dashed border-background-300 py-16 text-center">
          <span className="inline-flex w-16 h-16 items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-4">
            <i className="ri-heart-3-line text-3xl"></i>
          </span>
          <h2 className="text-lg font-bold text-foreground-900">还没有收藏任何内容</h2>
          <p className="mt-2 text-sm text-foreground-500">
            在详情页点击「收藏」按钮，喜欢的内容就会出现在这里。
          </p>
          <Link
            to="/"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
          >
            去发现内容
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      )}

      {recommended.length > 0 ? (
        <section className="mt-14">
          <SectionHeading title="为你推荐" subtitle="也许你会喜欢这些内容" icon="ri-sparkling-line" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {recommended.map((article) => (
              <ContentCard key={article.id} article={article} />
            ))}
          </div>
        </section>
      ) : null}
    </div>
  );
}